import { Injectable, inject, signal } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router
} from '@angular/router';

import {
  clearStaleChunkReload,
  isStaleChunkError,
  reloadForStaleChunk
} from '../utils/stale-chunk.util';

@Injectable({
  providedIn: 'root'
})
export class RouteLoadingService {
  private readonly router = inject(Router);

  readonly isLoading = signal<boolean>(false);
  readonly isChunkLoading = signal<boolean>(false);
  readonly targetUrl = signal<string | null>(null);

  constructor() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        const currentPath = this.router.url.split('?')[0].split('#')[0].replace(/\/+$/, '');
        const targetPath = event.url.split('?')[0].split('#')[0].replace(/\/+$/, '');
        if (currentPath !== targetPath) {
          this.isLoading.set(true);
        }
        this.targetUrl.set(event.url);
      } else if (event instanceof RouteConfigLoadStart) {
        this.isLoading.set(true);
        this.isChunkLoading.set(true);
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isChunkLoading.set(false);
      } else if (event instanceof NavigationEnd) {
        this.isLoading.set(false);
        this.isChunkLoading.set(false);
        this.targetUrl.set(null);
        clearStaleChunkReload();
      } else if (event instanceof NavigationCancel) {
        this.isLoading.set(false);
        this.isChunkLoading.set(false);
        this.targetUrl.set(null);
      } else if (event instanceof NavigationError) {
        this.isLoading.set(false);
        this.isChunkLoading.set(false);
        this.targetUrl.set(null);
        if (isStaleChunkError(event.error)) {
          reloadForStaleChunk(event.url);
        }
      }
    });
  }

  setPendingTarget(url: string | undefined): void {
    if (url) {
      this.isLoading.set(true);
      this.targetUrl.set(url);
    }
  }

  isRoutePending(link: string | undefined): boolean {
    if (!this.isLoading()) {
      return false;
    }
    const target = this.targetUrl();
    if (!target || !link) {
      return false;
    }
    const cleanTarget = target.split('?')[0].split('#')[0].replace(/\/+$/, '');
    const cleanLink = link.split('?')[0].split('#')[0].replace(/\/+$/, '');
    return cleanTarget === cleanLink;
  }
}
